export class Certificado {
    id: number;
    claveArchivo : string;
    nombreArchivo : string;
    nombreArchivoFirma : string;
    usuarioId : number;

    constructor(json? : any) {
        if (json != null) {
            this.id = json.id;
            this.claveArchivo = json.claveArchivo;
            this.nombreArchivo = json.nombreArchivo;
            this.nombreArchivoFirma = json.nombreArchivoFirma;
            this.usuarioId = json.usuarioId;     
        }
    }

    // Utils
    static toArray(jsons : any[]) : Certificado[] {
        let certificadoList : Certificado[] = [];
        if (jsons != null) {
            for (let json of jsons) {
                certificadoList.push(new Certificado(json));
            }
        }
        return certificadoList;
    }
}



// WEBPACK FOOTER //
// ./src/app/_seguridad/_certificado/certificado.ts